import { useCallback } from 'react';
import { Props } from '@sdk/components/forms/EditablePicker';
import PickerPersonaItem from '@sdk/components/forms/PickerPersonaItem';

import r2a from '../angularIntegration/r2a';

import EditablePickerWithDefault from './EditablePickerWithDefault';

const EditablePickerComponent = (props: Props) => {
  const { onChange } = props;
  const onChangeHandler = useCallback((item) => onChange({ item }), [onChange]);

  return (
    <EditablePickerWithDefault
      {...props}
      useOptionsFiltering
      onChange={onChangeHandler}
      renderItem={PickerPersonaItem}
    />
  );
};

export default r2a({
  ReactComponent: EditablePickerComponent,
  bindings: {
    options: '<',
    value: '<?',
    placeholder: '@?',
    onChange: '&?',
    invalidStateText: '@?',
  },
});
